"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pimSnapshotFragments = exports.pimSnapshotFragment = void 0;
exports.pimSnapshotFragment = `
  fragment pimSnapshot on PimSnapshot {
    id
    price
    priceExcludingVat
    leasingBasisPrice
    make
    series
    salesArticle
    fuelType
    electricRange
    effect
    powerTrain
  }
`;
exports.pimSnapshotFragments = `
  ${exports.pimSnapshotFragment}
`;
//# sourceMappingURL=pim-snapshot.js.map